import { render, staticRenderFns } from "./TreeController.vue?vue&type=template&id=65885a5d&"
import script from "./TreeController.vue?vue&type=script&lang=ts&"
export * from "./TreeController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports